import React from 'react';
import { connect } from 'react-redux';
import Layout from '../Layout/Layout';
import SpendingHowToSection from '../SpendingTracker/SpendingHowToSection';
import PayoffHowToSection from '../DebtPayoffTracker/PayoffHowToSection';
import { AscendState } from '../../ducks';

type StateProps = {
  signupMapping: string;
};

type HelpPageProps = StateProps;

const HelpPage: React.FC<HelpPageProps> = ({ signupMapping }) => {
  return (
    <Layout>
      <div style={{ marginTop: '25px' }}>
        <SpendingHowToSection value="1)" />
      </div>
      {signupMapping === 'flowBasicFreshStartE' ? (
        <div style={{ marginTop: '50px', marginBottom: '50px' }}>
          <PayoffHowToSection value="2)" />
        </div>
      ) : ''}
    </Layout>
  );
};

const mapStateToProps = (state: AscendState): StateProps => ({
  signupMapping: state.user.data.signupMapping,
});

export default connect(mapStateToProps)(HelpPage);